/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

function IssueForm(props) {
  const { handleChange } = props;
  return (
    <div className=" flex flex-col items-center w-full">
      <form className=" w-full xl:px-16 md:px-4 px-2">
        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full px-3 mb-3">
            <label
              htmlFor="issue"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              ISSUE
              <span className="text-red-500">*</span>
            </label>

            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-5 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="issue"
              name="occurrence"
              placeholder="TITLE OF ISSUE"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full md:w-1/2 px-3 mb-3">
            <label
              id="category"
              htmlFor="category"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              CATEGORY
              <span className="text-red-500">*</span>
            </label>
            <select
              className=" block w-full text-gray-700 border-b border-blue-500 md:h-16 h-12 bg-transparent py-3 px-4 mb-5 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="category"
              name="category"
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              <option value="Accident">OSHE</option>
              <option value="Minor">Aviation</option>
            </select>
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              htmlFor="position"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              PLACE/POSITION
              <span className="text-red-500">*</span>
            </label>

            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-5 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="position"
              name="place"
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              id="reoccuring"
              htmlFor="reoccuring"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              RE-OCCURING
              <span className="text-red-500">*</span>
            </label>
            <select
              className=" block w-full text-gray-700 border-b border-blue-500 md:h-16 h-12 bg-transparent py-3 px-4 mb-5 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="reoccuring"
              name="reoccuring"
              onChange={handleChange}
            >
              <option value="">Select Status</option>
              <option value="0">NO</option>
              <option value="1">YES</option>
            </select>
          </div>
        </div>
        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full md:w-1/2 px-3 mb-3">
            <label
              htmlFor="date"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              DATE
              <span className="text-red-500">*</span>
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-5 leading-tight focus:outline-none focus:bg-white"
              type="date"
              id="date"
              name="date_reported"
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              htmlFor="time"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              TIME
              <span className="text-red-500">*</span>
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              type="time"
              id="time"
              name="time"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full px-3">
            <label
              htmlFor="description"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              DESCRIPTION
              <span className="text-red-500">*</span>
            </label>
            <textarea
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 h-36 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              id="description"
              name="brief_notes"
              rows={10}
              cols={50}
              placeholder="Type your description here"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full px-3">
            <label
              htmlFor="recommendation"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              YOUR RECOMMENDATION ON FIXING THE PROBLEM
              <span className="text-red-500">*</span>
            </label>
            <textarea
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 h-24 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              id="recommendation"
              name="recommendation"
              rows={5}
              cols={50}
              placeholder="Type your recommendation here"
              onChange={handleChange}
            />
            <p className="text-gray-600 font-bold text-xs italic pt-6">
              Personal Information (If you want to get Feedback)
            </p>
          </div>
        </div>
        <div className="flex flex-wrap mx-3 mb-6">
          <div className="w-full md:w-1/2 px-3 mb-3">
            <label
              htmlFor="name"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              NAME
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="name"
              name="reported_by_name"
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              htmlFor="department"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              DEPARTMENT
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="department"
              name="reported_by_department"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="flex flex-wrap mx-3 mb-3">
          <div className="w-full md:w-1/2 px-3 mb-3">
            <label
              htmlFor="telephone"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              TELEPHONE
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="telephone"
              name="reported_by_tel"
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:w-1/2 px-3">
            <label
              htmlFor="email"
              className="block uppercase tracking-wide text-gray-700 lg:text-lg text-xs font-bold mb-2"
            >
              EMAIL
            </label>
            <input
              className="appearance-none block w-full text-gray-700 border-b border-blue-500 md:h-16 h-10 py-3 px-4 mb-4 leading-tight focus:outline-none focus:bg-white"
              type="text"
              id="email"
              name="reported_by_email"
              onChange={handleChange}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default IssueForm;

IssueForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
};
